package kpt.core.database

import androidx.room3.migration.Migration
import androidx.sqlite.SQLiteConnection
import androidx.sqlite.execSQL
import kotlin.Suppress

@Suppress(names = ["UNCHECKED_CAST", "DEPRECATION", "REDUNDANT_PROJECTION", "REMOVAL", "OPT_IN_USAGE_ERROR", "OPT_IN_USAGE", "MemberExtensionConflict", "CAN_BE_VAL"])
internal class AppDatabase_AutoMigration_11_12_Impl : Migration {
  public constructor() : super(11, 12)

  public override suspend fun migrate(connection: SQLiteConnection) {
    connection.execSQL("CREATE TABLE IF NOT EXISTS `framework_write_conflicts` (`id` INTEGER PRIMARY KEY AUTOINCREMENT NOT NULL, `entity` TEXT NOT NULL, `entityKey` TEXT NOT NULL, `localPayloadJson` TEXT NOT NULL, `serverPayloadJson` TEXT NOT NULL, `formRoute` TEXT, `recordedAtMs` INTEGER NOT NULL, `resolved` INTEGER NOT NULL)")
  }
}
